export const th = {
  shared_components: {
    common: {
      back: "ย้อนกลับ",
      confirm_cancel: "คุณแน่ใจที่จะยกเลิกหรือไม่?",
      current_executor: "ผู้รับมอบหมายปัจจุบัน: ",
      filter: "ค้นหา",
      inspector: "ผู้ตรวจสอบ",
      load_more: "ดึงขึ้นเพื่อโหลดเพิ่มเติม...",
      no: "ไม่",
      organization_structure: "องค์กร",
      please_enter: "โปรดกรอก",
      please_select: "โปรดเลือก",
      reject: "ปฏิเสธ",
      required_mark: "*",
      responsible_person: "ผู้รับผิดชอบ",
      status: "สถานะ",
      submit_date_end: "วันที่ส่ง (ถึง)",
      submit_date_start: "วันที่ส่ง (จาก)",
      yes: "ใช่",
      cancel: "ยกเลิก",
      confirm: "ยืนยัน",
      no_data: "ไม่มีข้อมูล",
      delete: "ลบ",
      save: "บันทึก",
      submit: "ส่ง",
      map_point: "MAP_POINT",
      view_floor_plan: "ดูแผนผังอาคาร",
      can_multi_select: "เลือกหลายรายการได้",
      choose_take_photo_msg: "ถ่ายภาพ",
      project_cost_center_code: "หน่วยรับผิดชอบ",
      project_name: "องค์กรที่รับผิดชอบ",
      choose: "เลือก ",
      get_data_failed: "ดึงข้อมูลล้มเหลว!",
      go_back_key_img: "กลับ",
      please_select_last_finding_category: "กรุณาเลือกหมวดหมู่ความเบี่ยงเบน/ข้อค้นพบระดับสุดท้าย",
      floor_plan: "แบบแปลนพื้น"
    },
    add_inspection_object: {
      inspection_obj_add: "เพิ่มวัตถุการตรวจสอบ",
      inspection_obj_input: "โปรดกรอกวัตถุการตรวจสอบ",
      inspect_object_key: "สิ่งที่ตรวจสอบ",
      add_must: "กรุณาเพิ่มวัตถุการตรวจสอบอย่างน้อยหนึ่งรายการ",
      other: "อื่นๆ"
    },
    corp_select: {
      please_select_last_location_for_inspection: "กรุณาเลือกสถานที่ตรวจสอบระดับสุดท้าย"
    },
    filter_modals: {
      capa_code: "เลข CAPA",
      capa_exec_date: "วันที่ตรวจสอบ/รับเรื่อง",
      capa_final_verifier: "ผู้ตรวจยืนยันขั้นสุดท้าย",
      capa_finding_desc: "คำอธิบายสิ่งที่พบ",
      capa_finding_evidence: "หลักฐานของสิ่งที่พบ",
      capa_finding_no: "เลขที่สิ่งที่พบ",
      capa_main_process: "กระบวนการหลัก",
      capa_person_in_charge: "ผู้รับผิดชอบ",
      capa_source: "แหล่ง CAPA",
      capa_subject_title: "หัวข้อ CAPA",
      capa_sub_process: "กระบวนการย่อย",
      completion_date: "วันที่สิ้นสุด",
      corrective_finished: "การแก้ไขเสร็จสิ้นหรือไม่?",
      data_scope: "ขอบเขตข้อมูล",
      ehsq_number: "ID การประเมิน",
      end_time: "วันที่สิ้นสุด",
      end_time_not_lg_start_time: "เวลาสิ้นสุดไม่สามารถน้อยกว่าเวลาเริ่มต้นได้",
      evaluation_method: "KPI ความปลอดภัย",
      following_field: "ฟิลด์ต่อไปนี้จะถูกสร้างขึ้นหลังจากบันทึกแบบฟอร์มงานแล้ว",
      from: "(จาก)",
      full_name: "ชื่อ-นามสกุล",
      hazard_type: "ประเภทอันตราย",
      help_center_doc_name: "ชื่อเอกสาร",
      immediate_check_category: "หมวดหมู่การตรวจสอบ",
      incident_informant: "ผู้แจ้งเหตุอุบัติการณ์",
      inspection_level: "INSPECTION_LEVEL",
      job_name: "งานที่กำลังปฏิบัติ",
      locations: "สถานที่",
      poba: "ส่วนของร่างกายที่ได้รับผลกระทบ",
      project_id: "ID โครงการ",
      project_name: "ชื่อโครงการ",
      rate: "การให้คะแนน",
      reporting_department: "แผนกที่รายงาน",
      responsibility_zone: "พื้นที่รับผิดชอบ",
      audit_reviewer: "ผู้ทบทวน",
      start_time: "วันที่เริ่มต้น",
      start_time_not_lg_end_time: "เวลาเริ่มต้นไม่สามารถมากกว่าเวลาสิ้นสุดได้",
      supplier_id: "ID ผู้รับเหมา",
      target_finished: "เป้าหมายสำเร็จหรือไม่?",
      task_code: "ID งาน",
      to: "(ถึง)",
      unsafe_behavior: "พฤติกรรมที่ไม่ปลอดภัย",
      unsafe_condition: "สภาพการณ์ที่ไม่ปลอดภัย",
      violation_item: "หมวดหมู่ข้อค้นพบ",
      work_id_id: "ID การปฏิบัติงาน",
      work_name: "ชื่อของงาน",
      work_related: "เกี่ยวข้องกับงาน",
      id_number: "หมายเลขประจำตัว",
      incident_involved_person: "ผู้เกี่ยวข้อง",
      incident_notifier_pro: "ผู้จัดการโครงการ",
      incident_reporting: "รายงานอุบัติการณ์",
      inspection_finding_category: "หมวดหมู่ข้อค้นพบ",
      inspection_form: "แบบฟอร์มตรวจสอบ",
      no: "ไม่",
      project_cost_center: "องค์กร",
      project_name_bbs: "องค์กรที่รับผิดชอบ",
      reviewer: "ผู้ตรวจสอบ",
      service_type: "ประเภทบริการ",
      submit_person: "ผู้สร้าง",
      verification_person: "ตรวจสอบโดย",
      yes: "ใช่",
      audit_type_display_key: "ประเภทการตรวจสอบ",
      business_line: "สายธุรกิจ",
      cancel_button_key: "ยกเลิก",
      check_table_table: "ตาราง",
      contractor_company: "บริษัทผู้รับเหมา",
      contractor_personnel_id: "ID บุคลากร",
      corrective_action_title_key: "การดำเนินการแก้ไข",
      due_date_end: "วันครบกำหนด (ถึง)",
      due_date_start: "วันครบกำหนด (จาก)",
      end_date: "วันที่สิ้นสุด",
      incident_category: "หมวดหมู่อุบัติการณ์",
      incident_location: "สถานที่เกิดอุบัติการณ์",
      incident_location_range: "ขอบเขตสถานที่",
      incident_organization: "องค์กรที่รับผิดชอบ",
      inspection_date_end: "วันที่ตรวจสอบ (ถึง)",
      inspection_date_start: "วันที่ตรวจสอบ (จาก)",
      observer: "ผู้สังเกตการณ์",
      occupation: "อาชีพ",
      org_operation: "ภูมิภาค",
      report_date_key: "วันที่รายงาน",
      report_time: "เวลารายงาน",
      reset: "รีเซ็ต",
      schedule_name: "ชื่อกำหนดการ",
      area: "พื้นที่",
      project: "โครงการ",
      years: "ปี",
      report_start_time: "วันที่เริ่มต้น",
      report_end_time: "วันที่สิ้นสุด",
      audit_type: "ประเภทการตรวจประเมิน",
      search_view_task_no_key: "รหัสภารกิจ:",
      select_upper_org_structure: "คุณต้องเลือกโครงสร้างองค์กรระดับบนก่อน",
      start_date: "วันที่เริ่มต้น",
      task_type: "ประเภทการตรวจสอบ",
      work_area: "พื้นที่ปฏิบัติงาน",
      work_risk_level: "ระดับความเสี่ยงของกิจกรรม",
      working_area: "พื้นที่ทำงาน",
      select_current_executor: "เลือกผู้ดำเนินการปัจจุบัน",
      select_final_verifier: "เลือกผู้ตรวจยืนยันขั้นสุดท้าย",
      select_person_in_charge: "เลือกผู้รับผิดชอบ",
      select_reporter: "เลือกผู้รายงาน",
      select_reviewer: "เลือกผู้ตรวจสอบ",
      select_verifier: "เลือกผู้ยืนยัน",
      incident_schedule: "ความคืบหน้า",
      task_name: "ชื่อโครงการ/งาน",
      incident_subject: "หัวข้ออุบัติการณ์",
      accident_number: "หมายเลขอุบัติเหตุ",
      select_capa_source: "เลือกแหล่งที่มา CAPA",
      search_capa_source: "ค้นหาแหล่งที่มา CAPA",
      select_factory: "เลือกโรงงาน",
      search_factory: "ค้นหาโรงงาน",
      search_employee: "ค้นหาพนักงาน"
    },
    gmp_floor_plan_dialog: {
      no_area_selected: "ยังไม่ได้เลือกพื้นที่",
      please_mark_one_point_on_floor_plan: "กรุณาทำเครื่องหมายหนึ่งจุดบนแปลนชั้น",
      reset_zoom: "รีเซ็ตการซูม",
      selected_areas: "พื้นที่ที่เลือก"
    },
    image_annotator_modal: {
      arrow: "↗ ลูกศร",
      cancel: "ยกเลิก",
      circle: "○ วงกลม",
      clear: "✕ ล้าง",
      pen: "✏ ปากกา",
      pinch_zoom: "🤏 บีบนิ้วเพื่อซูม",
      rect: "□ กล่อง",
      save: "บันทึกคำอธิบาย",
      text_tool: "T ข้อความ",
      title_arrow: "ลูกศร",
      title_circle: "วงกลม",
      title_pen: "ดินสอ",
      title_rect: "สี่เหลี่ยม",
      title_reset_zoom: "รีเซ็ตการซูม",
      title_text: "ข้อความ",
      undo: "↩ เลิกทำ"
    },
    my_title: {
      homepage: "หน้าแรก",
      enterprise_wechat_exit_home_alert: "Enterprise Wechat ออกจากหน้าหลัก"
    },
    no_source_img: {
      no_data: "ไม่มีข้อมูล"
    },
    org_select_modal: {
      choose_organization_structure: "เลือกองค์กร"
    },
    popover_dialog: {
      save_local: "บันทึกชั่วคราว"
    },
    return_dialog: {
      close_case: "ปิด",
      invalid: "ไม่ถูกต้อง"
    },
    select_picture: {
      choose_from_media_msg: "เลือกจากอัลบั้ม",
      confirm_delete_msg: "ยืนยันการลบหรือไม่?",
      get_image_fail: "ไม่สามารถรับรูปภาพได้"
    },
    select_picture_new: {
      attachement_download_fail: "ดาวน์โหลดไฟล์แนบล้มเหลว",
      be_uploading: "กำลังอัปโหลด",
      cancel_key: "ยกเลิก",
      load_from_gallery: "โหลดจากแกลเลอรี",
      select_image_source: "เลือกแหล่งที่มาของรูปภาพ",
      use_camera: "ใช้กล้อง",
      use_file: "โหลดจากไฟล์",
      camera_access_denied: "การเข้าถึงกล้องถูกปฏิเสธ กรุณาเปิดในตั้งค่าระบบ",
      camera_not_found: "ไม่พบกล้องในอุปกรณ์นี้"
    },
    spinner: {
      data_load_msg: "กำลังโหลดข้อมูล โปรดรอสักครู่..."
    },
    svg: {
      top: "ด้านบน"
    },
    turn_to_send: {
      mission_assign_success: "โอนงานสำเร็จ",
      report_member: "สมาชิกทีมสอบสวน",
      select_mission_assignee_msg: "กรุณาเลือกผู้รับโอนงาน!",
      turn_to_send: "มอบหมาย",
      turn_to_send_to: "มอบหมายงานให้",
      project_cost_center_code: "รหัสศูนย์ต้นทุนโครงการ"
    },
    select_file: {
      unsupported_format_desktop_only: "ไม่รองรับรูปแบบไฟล์แนบนี้ในขณะนี้ กรุณาดูผ่านคอมพิวเตอร์",
      format_not_supported: "รูปแบบไฟล์นี้ไม่รองรับการดูแบบออนไลน์ โปรดใช้อินเทอร์เฟซบนเว็บเพื่อดาวน์โหลดและเปิดดู"
    },
    fabric_canvas: {
      please_select_first: "ไม่มีวัตถุที่ถูกเลือก กรุณาเลือกวัตถุก่อน",
      delete_current_instance_only: "ลบไม่สำเร็จ คุณสามารถลบได้เฉพาะภาพวาดที่เกี่ยวข้องกับตำแหน่งนี้เท่านั้น"
    }
  }
};
